var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { attrs: { "justify-center": "" } },
            [
              _c("v-flex", { attrs: { xs8: "" } }, [
                _c("table", { staticStyle: { width: "100%" } }, [
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      _vm._l(_vm.sortItems(_vm.item.pkgItems), function(
                        pkg,
                        index
                      ) {
                        return _c(
                          "v-layout",
                          { key: String(pkg.tracking + index) },
                          [
                            _c(
                              "v-flex",
                              [
                                pkg.tracking === pkg.boxMark
                                  ? _c("span", [_vm._v(_vm._s(pkg.tracking))])
                                  : _c("span", [
                                      _c("span", [
                                        _vm._v(_vm._s(pkg.tracking))
                                      ]),
                                      _vm._v(" "),
                                      pkg.boxMark
                                        ? _c("span", [
                                            _vm._v(
                                              "[" + _vm._s(pkg.boxMark) + "]"
                                            )
                                          ])
                                        : _vm._e()
                                    ]),
                                _vm._v(" "),
                                _c(
                                  "v-icon",
                                  {
                                    attrs: { small: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          pkg.boxMark || pkg.tracking
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("content_copy")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            pkg.isCheckPackage
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(data) {
                                            return [
                                              _c(
                                                "v-flex",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      right: "",
                                                      md1: ""
                                                    }
                                                  },
                                                  data.on
                                                ),
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("add_task")
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("needCheckPackage")))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      _vm._l(_vm.sortItems(_vm.item.pkgItems), function(
                        pkg,
                        index
                      ) {
                        return _c("div", { key: String(pkg.upc + index) }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(pkg.upc) +
                              "\n              "
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      _vm._l(_vm.sortItems(_vm.item.pkgItems), function(
                        pkg,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            key: String(pkg.upc + index),
                            staticClass: "textOverflowHide"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  pkg.productName ||
                                    _vm.getProductName(pkg.upc) ||
                                    ""
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      _vm._l(_vm.sortItems(_vm.item.pkgItems), function(
                        pkg,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            key: String(pkg.upc + index),
                            class:
                              _vm.item.status === "partial" &&
                              pkg.forecastQty !== pkg.inboundQty
                                ? "partial_highlight"
                                : ""
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(pkg.forecastQty || 0) +
                                " /\n                " +
                                _vm._s(
                                  _vm.item.isPackageManagement &&
                                    !pkg.isCheckPackage &&
                                    pkg.inboundQty
                                    ? "**"
                                    : ""
                                ) +
                                "\n                " +
                                _vm._s(pkg.inboundQty || 0) +
                                "\n              "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52f3de8d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f3de8d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForecastTableExpand.vue
// module id = null
// module chunks = 